var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.genericStyles())},[(_vm.customData)?_c(_vm.template,{tag:"component",attrs:{"name":_vm.spec.template,"spec":_vm.customData}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }